import * as React from 'react';
import MuiButton from '@material-ui/core/Button';
import { Color } from './types';

type Variant = 'text' | 'outlined' | 'contained' | 'flat';

type Props = {
  disabled: boolean;
  fullWidth: boolean;
  variant: Variant;
  color: Color;

  onClick: () => void;

  children: any;
}

function Button(props: Props) {
  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();

    props.onClick(e);
  }

  return (
    <MuiButton
      disabled={props.disabled}
      fullWidth={props.fullWidth}
      variant={props.variant}
      color={props.color}
      onClick={onClick}
    >
      {props.children}
    </MuiButton>
  );
}

Button.defaultProps = {
  disabled: false,
  fullWidth: false,
  color: 'default',
  variant: 'contained',
};

export default Button;



// WEBPACK FOOTER //
// ./src/common/components/ui/Button.js